import { render, staticRenderFns } from "./NotificationManager.vue?vue&type=template&id=ad4b45a0&"
import script from "./NotificationManager.vue?vue&type=script&lang=js&"
export * from "./NotificationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports